import { Box } from '@opendoor/bricks-next';
import { AddressSearchLocation } from 'components/globals';
import { ILpComponentContextualFields } from 'declarations/contentful';

import NewSellerFlowAddressInput from '../../components/shared/NewSellerFlowAddressInput';
import { AgentSelectListBox, SupportListBox } from './shared/ListBox';
import { IComponentThemeOptions } from './shared/styles/ComponentTheme';

interface IContextualFieldProps {
  contextFields: ILpComponentContextualFields;
  theme: IComponentThemeOptions;
  inputLocation: AddressSearchLocation;
}

const ContextualField = ({ contextFields, theme, inputLocation }: IContextualFieldProps) => {
  const fields = contextFields.fields;

  // set the page set for address entry on home guide alt landing page
  const pageSetPath =
    contextFields.fields.analyticsId === 'homeguide-ae'
      ? '?seller_flow=home_guide_nav_entry'
      : undefined;

  // build agent links array
  const agentLinkOptions = [];
  if (contextFields.fields.agentLinkOneText && contextFields.fields.agentLinkOneUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkOneText,
      href: contextFields.fields.agentLinkOneUrl,
    });
  }

  if (contextFields.fields.agentLinkTwoText && contextFields.fields.agentLinkTwoUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkTwoText,
      href: contextFields.fields.agentLinkTwoUrl,
    });
  }

  if (contextFields.fields.agentLinkThreeText && contextFields.fields.agentLinkThreeUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkThreeText,
      href: contextFields.fields.agentLinkThreeUrl,
    });
  }

  switch (fields.contextualField) {
    case 'address-search':
      return (
        <>
          <Box
            id="desktop-address-search"
            zIndex={2}
            $largerThanSM={{ width: 512 }}
            $smallerThanMD={{ display: 'none' }}
          >
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={inputLocation}
              analyticsPrefix={contextFields.fields.analyticsId || ''}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholderText || 'Enter your home address'}
              pageSetPath={pageSetPath}
              trackingKeywords={contextFields.fields.trackingKeyword}
              channel={fields.channel ?? 'DEFAULT'}
            />
          </Box>
          <Box
            id="mobile-address-search"
            $largerThanSM={{ display: 'none' }}
            width={'100%'}
            zIndex={2}
          >
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={inputLocation}
              analyticsPrefix={contextFields.fields.analyticsId || ''}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholderTextSmall || 'Enter your home address'}
              pageSetPath={pageSetPath}
              trackingKeywords={contextFields.fields.trackingKeyword}
              channel={fields.channel ?? 'DEFAULT'}
            />
          </Box>
        </>
      );

    case 'agents':
      return <AgentSelectListBox theme={theme} linkOptions={agentLinkOptions} />;

    case 'support':
      return <SupportListBox theme={theme} />;

    default:
      return null;
  }
};

export default ContextualField;
